import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../services/data.service';
import { LanguageService } from '../../services/language-service';
import * as enJSON from '../../../../cs/cop/assets/i18n/en.json';
import * as frJSON from '../../../../cs/cop/assets/i18n/fr.json';

@Component({
    selector: 'cop-docs-feedback-form',
    templateUrl: './docs-feedback-form.component.html',
    styleUrls: ['./docs-feedback-form.component.scss'],
    standalone: false
})

export class DocsFeedbackFormComponent implements OnInit {

  formId: string = "";
  email: string = "";
  fieldDisable: boolean = false;
  docsFeedbackForm: UntypedFormGroup;
  mainPageLoader: boolean = false;
  hideForm: boolean = false;
  apiFailMsg: boolean = false;
  emailPattern: RegExp = /[a-zA-Z0-9-.-_(\\+)]{1,}@[a-zA-Z0-9.-]{2,253}[.]{1}[a-zA-Z]{2,}/; //Avaya email pattern
  localLangCode: string = "";
  categoryOptionsArr: any[] = [];

  constructor(private ds: DataService, private router: ActivatedRoute, private languageService: LanguageService) { }

  ngOnInit() {
    this.mainPageLoader = true;
    this.localLangCode = this.languageService.localCode;
    this.categoryOptionsArr = this.getTranslatedText("categoryOptionsArr");
    this.docsFeedbackForm = new UntypedFormGroup({
      name: new UntypedFormControl("", Validators.required),
      email: new UntypedFormControl("", [Validators.required, Validators.pattern(this.emailPattern)]),
      category: new UntypedFormControl("", Validators.required),
      url: new UntypedFormControl("", Validators.required),
      description: new UntypedFormControl("", Validators.required)
    });

    this.router.queryParams.subscribe(params => {
      if(params.formId)
        this.formId = params.formId;
      if(params.email) {
        this.email = params.email;
        this.fieldDisable = true;
      }
    });
    setTimeout(() => {
      if(this.email) {
        this.docsFeedbackForm.setValue({ name: "", email: this.email, category: "", url: "", description: "" });
        this.docsFeedbackForm.controls["email"].disable();
      }
      this.mainPageLoader = false;
    }, 2000);
  }

  onSubmitForm() {
    if(!this.formId) {
      alert("Form-Id is not patched with form. Please contact Avaya Customer-Care.");
      return;
    } else {
      this.mainPageLoader = true;
      let payload = {
        "formId": this.formId,
        "source": "Onecare",
        "questions": [
          { "qname": "summary", "qvalue": this.docsFeedbackForm.getRawValue().description, "qcontext": "summary" },
        ],
        "additionalinformation": [
          { "name": "name", "value": this.docsFeedbackForm.getRawValue().name },
          { "name": "email", "value": this.docsFeedbackForm.getRawValue().email },
          { "name": "category", "value": this.docsFeedbackForm.getRawValue().category },
          { "name": "url", "value": this.docsFeedbackForm.getRawValue().url },
        ]
      };

      this.ds.getITSSToken().subscribe((res: any) => {
        if(res && res.token) {
          this.ds.submitJiraTicket(payload, res.token).subscribe((data: any) => {
            if(data.returnCode === 0) {
              this.apiFailMsg = false;
              this.hideForm = true;
            } else {
              this.apiFailMsg = true;
              this.hideForm = false;
            }
            this.mainPageLoader = false;
          }, (error) => {
            this.mainPageLoader = false;
            this.apiFailMsg = true;
            this.hideForm = false;
            console.error("Form can not submit...", error);
          });
        } else {
          this.mainPageLoader = false;
          this.apiFailMsg = true;
          this.hideForm = false;
          console.error("Form can not submit, token fetching failed...", res);
        }
      });
    }
  }

  getTranslatedText(param: string) {
    if(this.localLangCode.includes('fr'))
      return frJSON[param];
    else
      return enJSON[param];
  }
}
